<template>
  <div>
    <v-card>
      <v-card-title>Listado de contratos</v-card-title>
      <v-card-text>
        <botonera :botones="botones" alinear="right" @crear="dialog = !dialog" @cargar="upload = !upload"
          @eliminar="deleteAll"></botonera>
      </v-card-text>
    </v-card>

    <datatable :cabeceras="contratosListHeaders" :items="contratosListBody" titulo="Listado de contratos"
      label="Escriba para buscar contratos" icono="list" color_icono="azul" :tachar="false"
      :acciones="['editar', 'eliminar', 'tarifas']" @editar="editContrato($event)" @eliminar="deleteContrato($event)"
      @tarifas="abrirContratosHistorico($event)">
    </datatable>

    <!-- Modal Nuevo Contrato -->
    <v-dialog v-model="dialog" width="800px" @click:outside="closeModal">
      <v-card>
        <v-card-title class="blue darken-1">{{ title }}</v-card-title>
        <v-card-text>
          <v-row class="mx-2">
            <v-col cols="3">
              <v-select prepend-icon="mdi-factory" v-model="contrato.tipo_acuerdo" :items="tipo_acuerdos"
                item-text="nombre" item-value="id" label="Tipo de Acuerdo" color="blue darken-3" persistent-hint
                return-object>
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-select prepend-icon="mdi-factory" v-model="contrato.empresa" :items="empresas" item-text="razon_social"
                item-value="id" label="Cliente" color="blue darken-3" persistent-hint return-object>
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-select prepend-icon="mdi-factory" v-model="contrato.wellboat" :items="wellboats" item-text="nombre"
                item-value="id" label="Wellboat" color="blue darken-3" persistent-hint return-object>
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-text-field prepend-icon="mdi-numeric" placeholder="Horas" label="Horas" v-model="contrato.horas">
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field prepend-icon="mdi-numeric" placeholder="Dolares" label="Dolares" v-model="contrato.dolares">
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field prepend-icon="mdi-numeric" placeholder="Dias pago" label="Dias pago"
                v-model="contrato.dias_pago">
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field prepend-icon="mdi-numeric" placeholder="Error ATS (%)" label="Error ATS (%)"
                v-model="contrato.error_ats_porc">
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field prepend-icon="mdi-numeric" placeholder="Error Cos (%)" label="Error Cos (%)"
                v-model="contrato.error_cos_porc">
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="closeModal">Cerrar</v-btn>
          <v-btn color="primary" @click="saveContrato">Grabar</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- / Modal -->

    <!-- Modal upload -->
    <v-dialog v-model="upload" width="600px">
      <v-card>
        <v-card-title class="green darken-1">
          Subir listado de contratos desde excel
        </v-card-title>
        <v-card-text>
          <v-row class="mx-2">
            <v-file-input v-model="file" accept=".xls, .xlsx" label="Archivo Excel"></v-file-input>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="upload = false">Cancelar</v-btn>
          <v-btn color="primary" @click="uploadContratos">Subir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal -->

    <v-snackbar v-model="snackbar" :timeout="5000" :color="color">
      {{ validation_message }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>


    <v-dialog v-model="dialogTarifas" max-width="900px" @click:outside="cerrarModalTarifas">
      <v-card>
        <v-card-title class="headline">
          Historial de Valores
          <v-spacer />
          <v-btn icon @click="cerrarModalTarifas">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-subtitle class="d-flex align-center flex-wrap py-3 px-4 mx-2 mt-2 mb-4 contrato-resumen">
          <span class="mr-2">Cliente</span>
          <strong class="mr-4">{{ contrato.empresa.razon_social }}</strong>

          <v-divider vertical class="mx-3" />

          <span class="mr-2">Wellboat</span>
          <strong>{{ contrato.wellboat.nombre }}</strong>
        </v-card-subtitle>

        <v-card-text>
          <!-- Agregar tarifa -->
          <v-row align="center">
            <v-col cols="12" sm="4">
              <v-text-field v-model="contrato_historico.vigente_desde" label="Vigente desde" type="date" outlined
                dense />
            </v-col>

            <v-col cols="12" sm="4">
              <v-text-field v-model.number="contrato_historico.dolares" label="Valor USD" type="number" min="0"
                step="0.01" outlined dense />
            </v-col>

            <v-col cols="12" sm="4">
              <v-btn color="primary" :disabled="!puedeAgregarTarifa" @click="agregarTarifa">
                {{ contrato_historico.id === null ? 'Agregar Tarifa' : 'Editar Tarifa' }}
              </v-btn>
            </v-col>
          </v-row>



          <!-- Historial -->
          <v-data-table :headers="headersTarifas" :items="tarifasHistoricas" dense
            no-data-text="No hay tarifas registradas">
            <template v-slot:item.vigente_desde="{ item }">
              {{ formatearFecha(item.vigente_desde) }}
            </template>

            <template v-slot:item.dolares="{ item }">
              {{ item.dolares }}
            </template>

            <template v-slot:item.estado="{ item }">
              <v-chip small :color="item.vigente ? 'green lighten-4' : 'grey lighten-3'">
                {{ item.vigente ? 'Vigente' : 'Histórico' }}
              </v-chip>
            </template>

            <template v-slot:item.editar="{ item }">
              <v-btn icon small color="warning" @click="editarTarifa(item)">
                <v-icon small>edit</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarModalTarifas">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  data: () => ({
    title: 'Nuevo Contrato',
    color: 'green',
    snackbar: false,
    errors: [],
    validation_message: '',
    search: null,
    file: null,
    dialog: false,
    upload: false,
    empresas: [],
    contratoIndex: -1,
    latitud: `40°28'20,00"`,
    longitud: `3°33'39,00"`,
    tipo_acuerdos: [],
    wellboats: [],
    contrato: {
      id: 0,
      tipo_acuerdo: {},
      empresa: {},
      wellboat: {},
      horas: '00:00',
      dias_pago: 0,
      dolares: 0,
      error_ats_porc: 0,
      error_cos_porc: 0,
    },
    contrato_historico: {
      id: null,
      contratos_id: null,
      vigente_desde: null,
      dolares: null
    },
    contratosListHeaders: [
      {
        text: 'Id',
        align: 'center',
        sortable: true,
        value: 'id',
        class: "blue-grey darken-4 white-text"
      },
      {
        text: 'Empresa',
        align: 'center',
        sortable: true,
        value: 'empresa.razon_social',
        class: "blue-grey darken-4 white-text"
      },
      {
        text: 'Tipo de acuerdo',
        align: 'center',
        sortable: true,
        value: 'tipo_acuerdo.nombre',
        class: "blue-grey darken-4 white-text"
      },
      {
        text: 'Wellboat',
        align: 'center',
        sortable: true,
        value: 'wellboat.nombre',
        class: "blue-grey darken-4 white-text"
      },
      {
        text: 'Horas',
        align: 'center',
        sortable: true,
        value: 'horas',
        class: "blue-grey darken-4 white-text"
      },
      {
        text: 'Dolares',
        align: 'center',
        sortable: true,
        value: 'dolares',
        class: "blue-grey darken-4 white-text"
      },
      {
        text: 'Dias pago',
        align: 'center',
        sortable: true,
        value: 'dias_pago',
        class: "blue-grey darken-4 white-text"
      },
      {
        text: 'Error ATS (%)',
        align: 'center',
        sortable: true,
        value: 'error_ats_porc',
        class: "blue-grey darken-4 white-text"
      },
      {
        text: 'Error COS-RTP (%)',
        align: 'center',
        sortable: true,
        value: 'error_cos_porc',
        class: "blue-grey darken-4 white-text"
      },
      {
        text: 'Acciones',
        align: 'center',
        sortable: false,
        value: 'actions',
        class: "blue-grey darken-4 white-text"
      },
    ],
    contratosListBody: [],
    botones: [
      { boton: 'crear', tooltip: 'Nuevo Contrato' },
      { boton: 'cargar', tooltip: 'Carga Masiva' },
      { boton: 'eliminar', tooltip: 'Borrar Todo' }
    ],
    dialogTarifas: false,
    headersTarifas: [
      { text: 'Vigente desde', value: 'vigente_desde' },
      { text: 'Valor USD', value: 'dolares' },
      { text: 'Estado', value: 'estado', sortable: false },
      { text: 'Editar', value: 'editar', sortable: false },
    ],
    tarifasHistoricas: [],
  }),
  mounted() {
    this.loadEmpresas();
    this.loadTipoAcuerdos();
    this.loadWellboats();
    this.loadContratos();
  },
  methods: {
    async loadEmpresas() {
      let url = `${this.base_url}empresas`;
      await this.axios.get(url, this.headers).then((response) => {
        this.empresas = response.data;
        this.contrato.empresa = this.empresas[0];
      }).catch((error) => {
        console.log(error);
      });
    },
    async loadTipoAcuerdos() {
      let url = `${this.base_url}tipo_acuerdos`;
      await this.axios.get(url, this.headers).then((response) => {
        this.tipo_acuerdos = response.data;
        this.contrato.tipo_acuerdo = this.tipo_acuerdos[0];
      }).catch((error) => {
        console.log(error);
      });
    },
    async loadWellboats() {
      let url = `${this.base_url}wellboats`;
      await this.axios.get(url, this.headers).then((response) => {
        this.wellboats = response.data;
        this.contrato.wellboat = this.wellboats[0];
      }).catch((error) => {
        console.log(error);
      });
    },
    async loadContratos() {
      this.mostrarLoading('Cargando listado de contratos...')
      let url = `${this.base_url}contratos`;
      await this.axios.get(url, this.headers).then((response) => {
        this.contratosListBody = response.data;
        this.ocultarLoading()
      }).catch((error) => {
        console.log(error);
        this.ocultarLoading()
      });
    },
    async saveContrato() {
      // validation
      this.errors = [];
      if (!this.contrato.tipo_acuerdo) {
        this.errors.push("Debe indicar el tipo de acuerdo");
      }
      if (!this.contrato.wellboat) {
        this.errors.push("Debe indicar wellboat");
      }
      if (!this.contrato.dolares) {
        this.errors.push("Debe indicar dolares");
      }
      if (!this.contrato.dias_pago) {
        this.errors.push("Debe indicar dias pago");
      }
      if (!this.contrato.error_ats_porc) {
        this.errors.push("Debe indicar error ATS");
      }
      if (!this.contrato.error_cos_porc) {
        this.errors.push("Debe indicar error COS-RPT");
      }
      if (this.contrato.empresa == null) {
        this.errors.push("Debe seleccionar una empresa");
      }
      if (this.errors.length > 0) {
        this.validation_message = this.errors.join();
        this.showSnackBar(true);
        return;
      }
      let url = `${this.base_url}contratos`;
      let contratoData = {
        'tipo_acuerdos_id': this.contrato.tipo_acuerdo.id,
        'empresas_id': this.contrato.empresa.id,
        'wellboats_id': this.contrato.wellboat.id,
        'horas': this.contrato.horas,
        'dolares': this.contrato.dolares,
        'dias_pago': this.contrato.dias_pago,
        'error_ats_porc': this.contrato.error_ats_porc,
        'error_cos_porc': this.contrato.error_cos_porc,
      };
      if (this.contrato.id > 0) {
        url = url + "/" + this.contrato.id;
        await this.axios.put(url, contratoData, this.headers).then((response) => {
          let index = this.contratosListBody.map(contrato => {
            return contrato.id;
          }).indexOf(this.contrato.id);
          this.contratosListBody.splice(index, 1, response.data);
          this.showSnackBar(false);
        }).catch((error) => {
          console.log(error);
          this.showSnackBar(true);
        });
      } else {
        await this.axios.post(url, contratoData, this.headers).then((response) => {
          this.contratosListBody.push(response.data);
          this.showSnackBar(false);
        }).catch((error) => {
          this.errors = error.response.data;
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
        });
      }
      this.cleanForm();
    },
    editContrato(item) {
      this.contratoIndex = this.contratosListBody.indexOf(item);
      this.contrato = Object.assign({}, item);
      this.dialog = true;
      this.title = "Editar Contrato";
    },
    async deleteContrato(item) {
      this.$confirm('Desea borrar este contrato?').then(res => {
        if (res) {
          let url = `${this.base_url}contratos/${item.id}`;
          this.axios.delete(url, this.headers).then((response) => {
            console.log(response);
            const index = this.contratosListBody.indexOf(item);
            this.contratosListBody.splice(index, 1);
            this.showSnackBar(false);
          }).catch((error) => {
            this.validation_message = error;
            this.showSnackBar(true);
          });
        }
      });
    },

    abrirContratosHistorico(item) {
      console.log('item', item)
      this.contrato = item
      this.contrato_historico.contratos_id = item.id
      this.tarifasHistoricas = item.contratos_historico
      this.dialogTarifas = true
    },
    showSnackBar(error) {
      if (error) {
        this.color = 'red';
      } else {
        this.color = 'green';
        this.validation_message = "Ejecutado exitosamente!";
      }
      this.snackbar = true;
    },
    closeModal() {
      this.cleanForm();
      this.dialog = false;
      this.error = null;
      this.title = "Nuevo Contrato";
    },
    cleanForm() {
      this.contrato.id = 0;
      this.contrato.nombre = "";
      this.contrato.latitud = "";
      this.contrato.longitud = "";
      this.contrato.empresa = null;
      this.dialog = false;
    },
    async uploadContratos() {
      this.headers.headers['Content-Type'] = "multipart/form-data";
      let url = `${this.base_url}uploads/contratos`;
      let formData = new FormData();
      formData.append("excel", this.file);
      let response = null;
      try {
        response = await this.axios.post(url, formData, this.headers);
        this.file = null;
        this.upload = false;
        this.loadContratos();
        this.showSnackBar(false);
      } catch (error) {
        response = error.response;
        let msg = response.data.data;
        this.validation_message = response.status + ': ' + response.data.message + '. ' + msg;
        this.showSnackBar(true);
      }
    },
    async deleteAll() {
      this.$confirm('Desea borrar todos los datos?').then(res => {
        if (res) {
          let url = `${this.base_url}truncar/contratos`;
          this.axios.get(url, this.headers).then((response) => {
            console.log(response);
            this.loadContratos();
            this.showSnackBar(false);
          }).catch((error) => {
            this.validation_message = error;
            this.showSnackBar(true);
          });
        }
      });
    },
    formatearFecha(fecha) {
      if (!fecha) return ''
      const [anio, mes, dia] = fecha.substring(0, 10).split('-')
      return `${dia}-${mes}-${anio}`
    },

    async agregarTarifa() {

      const url = `${this.base_url}contratos-historico/guardar-tarifa`;
      const tarifaData = {
        id: this.contrato_historico.id,
        contratos_id: this.contrato_historico.contratos_id,
        vigente_desde: this.contrato_historico.vigente_desde,
        dolares: this.contrato_historico.dolares,
      };

      try {
        const response = await this.axios.post(url, tarifaData, this.headers);
        const tarifa = response.data.data;

        const index = this.tarifasHistoricas.findIndex(item => item.id === tarifa.id);

        if (index >= 0) {
          this.tarifasHistoricas.splice(index, 1, tarifa);
        } else {
          this.tarifasHistoricas.push(tarifa);
        }

        this.tarifasHistoricas.sort((a, b) =>
          a.vigente_desde.localeCompare(b.vigente_desde)
        );

        if (tarifa.vigente) {
          this.tarifasHistoricas.forEach(item => {
            if (item.contratos_id === tarifa.contratos_id) {
              item.vigente = item.id === tarifa.id;
            }
          });
          const contrato = this.contratosListBody.find(
            item => item.id === tarifa.contratos_id
          );

          if (contrato) {
            contrato.dolares = tarifa.dolares;
          }
        }

        this.contrato_historico = {
          id: null,
          contratos_id: null,
          vigente_desde: null,
          dolares: null,
        };

        this.showSnackBar(false);
      } catch (error) {
        console.log(error);
        this.errors = error.response?.data?.errors
          ? Object.values(error.response.data.errors).flat()
          : [error.response?.data?.message || "No se pudo guardar la tarifa"];

        this.validation_message = this.errors.join(", ");
        this.showSnackBar(true);
      }
    },

    editarTarifa(item) {
      this.contrato_historico = {
        id: item.id,
        contratos_id: item.contratos_id,
        vigente_desde: item.vigente_desde
          ? item.vigente_desde.substring(0, 10)
          : null,
        dolares: item.dolares,
      }
    },

    cerrarModalTarifas() {
      this.dialogTarifas = false
      this.contrato_historico = {
        id: null,
        contratos_id: null,
        vigente_desde: null,
        dolares: null,
      }
    },
    ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
  },
  computed: {
    ...mapState(['loading', 'base_url', 'headers']),
    puedeAgregarTarifa() {
      return this.contrato_historico.vigente_desde && this.contrato_historico.dolares !== null
    },
  },
  components: {
    //'datatable':DataTable
  }
}
</script>
<style>
.contrato-resumen {
  background: #f3f6f8;
  color: #455a64;
  border-left: 4px solid #1976d2;
  font-size: 15px;
}

.contrato-resumen strong {
  color: #263238;
}
</style>